import React from 'react';
import * as S from './InvoicesListSkeleton.styles';
import { SkeletonLoader } from '@/components/SkeletonLoader/SkeletonLoader';

interface InvoicesListSkeletonProps {
  itemsCount?: number;
  hasContainer?: boolean;
}

const DEFAULT_ITEMS_COUNT = 8;

export function InvoicesListSkeleton({
  itemsCount = DEFAULT_ITEMS_COUNT,
  hasContainer = true,
}: InvoicesListSkeletonProps) {
  const content = Array.from({ length: itemsCount }).map((_, index) => (
    <S.Item key={index}>
      <S.Content>
        <S.TopRow>
          <SkeletonLoader width="60%" height={18} borderRadius={7} />
          <SkeletonLoader width={80} height={18} borderRadius={7} />
        </S.TopRow>
        <S.BottomRow>
          <SkeletonLoader width={100} height={18} borderRadius={7} />
          <SkeletonLoader width={80} height={18} borderRadius={7} />
        </S.BottomRow>
      </S.Content>

      <S.Icons>
        <S.DownloadSlot>
          <SkeletonLoader width={20} height={20} borderRadius={7} />
        </S.DownloadSlot>

        <S.Chevron>
          <SkeletonLoader width={6} height={12} borderRadius={7} />
        </S.Chevron>
      </S.Icons>
    </S.Item>
  ));

  return hasContainer ? <S.Container>{content}</S.Container> : content;
}
